import { useHttp } from '@/shared/lib'
import { useQuery } from '@tanstack/vue-query'
import { type Ref } from 'vue'

/**
 * Функция загрузки табов
 */
export const useLoadTabs = () => {
  const http = useHttp()

  return useQuery({
    queryKey: ['load_tabs'],
    queryFn: () => http.get(`/tabs`),
    retry: false,
  })
}

/**
 * Функция загрузки списка определенного таба
 */
export const useLoadTab = (tabId: Ref<string>) => {
  const http = useHttp()

  return useQuery({
    queryKey: ['load_tab', tabId],
    queryFn: () => http.get(`/tabs/${tabId.value}`),
    retry: false,
    enabled: Boolean(tabId.value),
  })
}
